import { TwitchAuthCodeResponse } from '@/models/twitch-auth-code-response.model';
import http from './http-client';

export class AuthService {
  public loginWithTwitch(twitchAuthCodeResponse: TwitchAuthCodeResponse): Promise<any> {
    return http.post('/login/twitch', twitchAuthCodeResponse);
  }
}